module.exports = __webpack_public_path__ + "assets/img/chef-4.91deed9a.jpg";